import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  name() {
    return faker.company.name();
  },

  city() {
    return faker.address.city();
  },

  cityEn() {
    return `${this.city} EN`;
  },

  dgg() {
    return faker.datatype.boolean();
  },

  street() {
    return faker.address.street();
  },

  zipcode() {
    return faker.address.zipCode('#####');
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },

  afterCreate(livePartner, server) {
    livePartner.update({
      logo: server.create('asset'),
      link: server.create('link'),
      partnerType: server.create('category', 'partnerTypeLive'),
      country: server.create('category', 'country'),
    });
  },
});
